import * as Sentry from "@sentry/react";
import { Dedupe } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";

import { AxiosError } from "axios";
import { SENTRY_DSN } from "@/constants/AppConstants";
import packageInfo from "../../package.json";

Sentry.init({
  dsn: SENTRY_DSN,
  maxBreadcrumbs: 10,
  attachStacktrace: true,
  tracesSampleRate: 0.01,
  integrations: [
    new Dedupe(),
    new Integrations.BrowserTracing({
      tracingOrigins: ["*"],
    }),
  ],
  environment: process.env.REACT_APP_ENV,
  release: packageInfo.version,
});

export const captureException = (error: AxiosError | Error) => {
  Sentry.configureScope((scope) => {
    if ("response" in error && error.response?.status)
      scope.setExtra("statusCode", error.response.status);
    scope.setExtra("query", window.location.search);
    scope.setExtra("pathname", window.location.pathname);
  });
  return Sentry.captureException(error);
};

export default Sentry;
